import useTestId from '@ori/testid-generator';
import { ITEMS_COUNTER } from "./constants";
import { Root } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Component for displaying number of items on a listing page.
 * Renders if `text` has thruthy value.
 */
export var ItemsCounter = function ItemsCounter(_ref) {
  var text = _ref.text,
    className = _ref.className;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  if (!text) {
    return null;
  }
  return /*#__PURE__*/_jsx(Root, {
    className: className,
    "data-testid": getTestId(ITEMS_COUNTER),
    children: text
  });
};
//# sourceMappingURL=ItemsCounter.js.map